<template>
    <div class="body__container-background">
        <div class="overflow-hidden position-relative">
            <div class="position-change position-change__grassbox">
                <img class="grass position-change__grass"
                     src="@/assets/images/404/error_desk_grass.png"
                     width="100px"
                     alt="保險手札枯枝">
                <img class="position-change__grass-shadow"
                     src="@/assets/images/404/error_desk_grass_shadow.png"
                     alt="保險手札枯枝影子">
            </div>
            <div class="container body__container">
                <div class="container__content">
                    <div class="container__content__box">
                        <div class="container__content__box__imgsbox">
                            <img class="container__content__role"
                                 src="@/assets/images/404/error_desk_role.png"
                                 alt="保險手札哭泣的邦肯">
                        </div>
                        <div class="container__div-404">
                            <div class="container__div-404__images">
                                <img class="container__div-404__404"
                                     src="@/assets/images/404/erroe_desk_404.png"
                                     alt="保險手札錯誤代碼404">
                            </div>
                            <h2 class="font-setting my-3">很抱歉!找不到存在的頁面</h2>
                            <h4 class="font-setting mb-2">請嘗試回到主頁繼續你的旅程</h4>
                            <div class="btn-back-to-home font-setting"
                                 :data-ga-element="`新保險網站｜404｜返回主頁`"
                                 @click="goPage()">返回主頁</div>
                        </div>
                        <div class="position-change position-change__planetbox">
                            <img class="position-change__planet"
                                 src="@/assets/images/404/error_desk_planet.png"
                                 alt="保險手札沙漠仙人掌">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Error',
    methods: {
        goPage() {
            this.$router.push({ name: 'Home' });
        },
    },
};
</script>
<style lang="scss" scoped>
.body__container-background {
    background: url('../assets/images/404/error_desk_bg.png') no-repeat center
        center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
}

/* .body-background-color {
    background-color: #f0c6a6;
} */

.body__container {
    display: flex;
    justify-content: center;
    width: 100% !important;
    height: 100vh !important;
}

.font-setting,
.font-setting:hover {
    color: #5f3e52;
    font-weight: 900;
}

.container__content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    z-index: 3;
    position: relative;
}

.container__content__box__imgsbox {
    text-align: center;
    margin-bottom: 20px;
}

.container__content__box {
    display: flex;
    align-items: flex-end;
}

.container__div-404 {
    text-align: center;
    margin-right: -3vw;
    margin-left: 3vw;
    padding-bottom: 3vh;
}

.btn-back-to-home,
.btn-back-to-home:active,
.btn-back-to-home:hover,
.btn-back-to-home:active {
    text-decoration: none;
    padding: 8px 43px;
    border-radius: 50px;
    background-color: white;
    box-shadow: -3px 3px 2px #85624f;
    display: inline-block;
    font-size: 20px;
}

.container__div-404 h2 {
    font-size: 27px;
}

.container__div-404__404 {
    max-width: 300px;
}

.container__content__role {
    max-width: 200px;
}

.position-change__grassbox {
    top: 50%;
    right: -200px;
    z-index: 3;
    position: absolute;
}

.position-change__grass {
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 2;
}

.position-change__grass-shadow {
    position: absolute;
    top: 40px;
    right: 0px;
    z-index: 1;
}

.position-change__grass-shadow {
    animation-name: moving;
    animation-duration: 10s;
    animation-fill-mode: forwards;
    animation-direction: normal;
    animation-timing-function: linear;

    animation-iteration-count: infinite;
}

.position-change__grass {
    animation: moving 10s linear 0s infinite normal,
        grass-rotate 1s linear 0s infinite reverse;
}

.overflow-hidden {
    overflow: hidden;
}

@media screen and (max-width: 768px) {
    .container__content__box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .body__container-background {
        background: url('../assets/images/404/error_mobile_bg.png') no-repeat
            center center fixed;
        background-size: cover;
    }
    .container__div-404 {
        margin-right: 0px;
        margin-left: 0px;
        padding-bottom: 0px;
    }
    .container__content__role {
        width: 40vw;
        max-width: 200px;
    }
    .container__div-404__404 {
        width: 60vw;
        max-width: 314px;
    }
    .btn-back-to-home,
    .btn-back-to-home:active,
    .btn-back-to-home:hover,
    .btn-back-to-home:active {
        padding: 8px 25px;
        font-size: 15px;
    }
    .container__div-404 h2 {
        font-size: 20px;
    }
    .container__div-404 h4 {
        font-size: 12px;
    }
    .position-change {
        position: absolute;
    }
    .position-change__planet {
        width: 20vw;
        max-width: 100px;
        top: 0px;
    }
    .position-change__grass {
        width: 8vw;
    }

    .position-change__grass-shadow {
        top: 3vh;
        width: 12vw;
    }
    .container__content__box {
        position: relative;
    }
    .position-change__planetbox {
        top: 20%;
        right: -25px;
    }
    .position-change__grassbox {
        top: 35%;
    }
}

/* 動畫 */

@keyframes moving {
    from {
        right: 0px;
    }
    to {
        right: 180vw;
    }
}

@keyframes grass-rotate {
    100% {
        transform: rotate(360deg);
    }
}

/* @keyframes moving-small {
    from {
        left: 0px;
    }
    to {
        right: 100px;
    }
} */
</style>
